module.exports = __webpack_public_path__ + "static/3-1b7a6b3b03eb8e616a30972224c54c8c.png";